import React, { useState, useEffect, useContext } from 'react'
import { getFAQ } from '../api'
import { LocaleContext } from '../routes'
import HelpItem from '../views/HelpItem'
import { LabelExtra } from '../styles/elements'
import Loading from '../views/common/Loading'
import Header from '../views/common/Header'
import { Container } from '../styles/elements'

const useFAQ = () => {
  const [FAQs, setFAQs] = useState()
  const [loading, setLoading] = useState()

  useEffect(() => {
    const getHelp = async () => {
      setLoading(true)
      const FAQsResponse = await getFAQ()
      setLoading(false)
      setFAQs(FAQsResponse)
    }
    getHelp()
  }, [])

  return [FAQs, loading]
}


export default ({ loyalty: { status: { point } } }) => {
  const locale = useContext(LocaleContext)
  const [FAQs, loading] = useFAQ()
  const HelpTitle = props => <LabelExtra {...props} color="#6d6d6d" padding="0 0 8px" />

  return (
    loading ?
      <Loading />
      :
      <>
      <Header score={point} />
      <Container>
        <HelpTitle>{locale.HELP_CAPTION}:</HelpTitle>
        {FAQs && FAQs.faq.map((faq, index) =>
          <HelpItem key={index} faq={faq} />
        )}
      </Container>
      </>
  )
}